module.exports = __webpack_public_path__ + "img/practice-pol.d03c57a1.svg";